import { initializeTracker } from '../analytic/outbound-link-tracker';

export default (): void => {
  initializeTracker(window);
};
